import { c as _c } from "react/compiler-runtime";
import { type ElementType, type PropsWithChildren, type ReactNode, useState } from 'react';
import { cx } from '../../cx';
import { useResizeObserverRef } from '../../hooks/use-resize-observer-ref';
import { uiTestId } from '../../test-ids';
type ModalContentProps = PropsWithChildren<{
  className?: string;
  Root?: ElementType;
  disableScrollBorder?: boolean;
  renderFooter?: () => ReactNode;
}>;
export const Content = t0 => {
  const $ = _c(16);
  const {
    className,
    Root: t1,
    disableScrollBorder,
    renderFooter,
    children
  } = t0;
  const Root = t1 === undefined ? "div" : t1;
  const [isScrollable, setIsScrollable] = useState(false);
  let t2;
  if ($[0] !== disableScrollBorder) {
    t2 = t3 => {
      const [entry] = t3;
      if (disableScrollBorder) {
        return;
      }
      setIsScrollable(entry.target.scrollHeight > entry.target.clientHeight);
    };
    $[0] = disableScrollBorder;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [ref] = useResizeObserverRef(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = uiTestId("ModalContent.content");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isScrollable && "border-y-primary/15";
  let t5;
  if ($[3] !== className || $[4] !== t4) {
    t5 = cx("scrollbar-none flex-1 overflow-y-auto overflow-x-hidden border-transparent border-t border-b p-6 sm:px-8", t4, className);
    $[3] = className;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== ref || $[8] !== t5) {
    t6 = <div ref={ref} className={t5}>{children}</div>;
    $[6] = children;
    $[7] = ref;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== renderFooter) {
    t7 = renderFooter?.();
    $[10] = renderFooter;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== Root || $[13] !== t6 || $[14] !== t7) {
    t8 = <Root className="flex h-full max-h-full flex-1 flex-col overflow-y-hidden" data-testid={t3}>{t6}{t7}</Root>;
    $[12] = Root;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};